module.exports = __webpack_public_path__ + "static/media/Somi-icon-01-01-md.557ac0e7.png";